// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
// rxjs
import { combineLatest, Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

// Misc
import { claimQuery } from '@amfam/claim/data-access';
import { eligibleServicesQuery } from '@amfam/claim/post-fnol/services-data-access';
// Store
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../../core/store';

@Injectable()
export class PostFnolGuard {
  constructor(private store: Store<fromRoot.RootState>) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return combineLatest(
      this.store.select(eligibleServicesQuery.getEligibleServicesState),
      this.store.select(claimQuery.selectSelectedClaim),
      (eligibleServicesState, claim) => {
        return {
          eligibleServicesState,
          claim
        };
      }
    ).pipe(
      take(1),
      switchMap(state => {
        if (_get(state, 'eligibleServicesState.claimNumber') === _get(state, 'claim.claimNumber')) {
          return of(true);
        }

        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/claims']
          })
        );
        return of(false);
      })
    );
  }
}
